exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iframe-full-width {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  bottom: 0px;\n  right: 0px;\n  width: 100%;\n  height: 100%;\n  border: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  z-index: 999999; }\n  .iframe-full-width .header {\n    position: fixed; }\n  .iframe-full-width iframe {\n    padding-top: 80px;\n    border: none; }\n\n@media (max-width: 767px) {\n  .iframe-full-width .dialog__content {\n    padding: 0; }\n  .iframe-full-width iframe {\n    padding-top: 60px; } }\n", ""]);

// exports
